import { render, staticRenderFns } from "./UserPasswordResetConfirm.vue?vue&type=template&id=fa2f01f0&scoped=true"
import script from "./UserPasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./UserPasswordResetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2f01f0",
  null
  
)

export default component.exports